import Image from "next/image";
import Link from "next/link";
import { format } from "date-fns";

const Card = ({ heading, date, desc, author, img, link, linkSource }) => (
  <a className="cursor-pointer" href={link}>
    <div
      className={
        "w-full h-full rounded-md shadow-md overflow-hidden flex flex-col space-y-2 bg-white text-black"
      }
    >
      <div className={"w-full relative overflow-hidden h-[220px]"}>
        <Image
          className="resposive-image"
          layout={"fill"}
          objectFit={"cover"}
          src={img}
        />
      </div>
      <div className={"flex flex-col flex-1 p-4 space-y-1 justify-between"}>
        <div className={"flex flex-col space-y-1"}>
          <h6 className={"text-md"}>{heading}</h6>
          <p className={"text-xs text-gray-50"}>
            {author} - {format(new Date(date), "MMMM dd, yyyy")}
          </p>
        </div>
        <p className={"text-xs text-gray-50"}>{desc}</p>
        <div className={"pt-4"}>
          <Link href={link}>
            <a className={"text-primary text-xs"}>{linkSource}</a>
          </Link>
        </div>
      </div>
    </div>
  </a>
);

export default Card;
